import { createApiConstants } from '@saucelabs/sl-util-redux';

import { NAMESPACE } from '../../constants';

const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const FETCH_RECURLY_TOKEN = createApiNamespacedConstants('FETCH_RECURLY_TOKEN');
export const RECURLY_COMPONENT_FETCH = `${NAMESPACE}/RECURLY_COMPONENT_FETCH`;
export const RECURLY_COMPONENT_READY = `${NAMESPACE}/RECURLY_COMPONENT_READY`;
export const PAYMENT_INFO_SAVED = `${NAMESPACE}/PAYMENT_INFO_SAVED`;
export const CARD_DETAILS_SAVED = `${NAMESPACE}/CARD_DETAILS_SAVED`;
export const CARD_VALID_SAVED = `${NAMESPACE}/CARD_VALID_SAVED`;
export const PAYMENT_METHOD_CHANGED = `${NAMESPACE}/PAYMENT_METHOD_CHANGED`;

export const FETCH_ACCOUNT = createApiNamespacedConstants('FETCH_ACCOUNT');
export const UPDATE_ACCOUNT = createApiNamespacedConstants('UPDATE_ACCOUNT');
export const UPDATE_BILLING_INFO = createApiNamespacedConstants('UPDATE_BILLING_INFO');
